import Section from './_Section'
import RatesCalloutWrapper from '../helpers/RatesCalloutWrapper'
import { transformPaddingToTailwind } from '../../helpers/style'
import themeConfig from '../../../theme.config'

function RatesCalloutCard(props) {
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  return (
    <Section type="ratesCalloutCard" outerClass={componentPadding} sectionTitle={false} innerClass="px-6" {...props}>
      <RatesCalloutWrapper {...props} />
    </Section>
  )
}

export default RatesCalloutCard
